import React, { useEffect, useState } from 'react';
import Spinner from './components/spinner';
import Error from './components/error';
import Receipt from './components/reciept';

import { dispatchLead, debugReciept, dispathErrorEvent, ERROR_FLAG } from '@nettbureau/kvittering-utils';

const getUrlParam = (paramName) => {
  const urlParams = new URLSearchParams(window.location.search);
  const value = urlParams.get(paramName);
  return value;
};

export default function () {
  const [loading, setLoading] = useState(true);
  const [flag, setFlag] = useState(false);
  const [vendorList, setVendorlist] = useState([]);
  const [internalSales, setInternalSales] = useState(false);

  const status = getUrlParam('status');

  if (status !== null) {
    useEffect(() => debugReciept(status, setLoading, setFlag, setVendorlist, true), [status]);
  } else {
    useEffect(() => dispatchLead(setLoading, setFlag, setVendorlist, true), []);
  }

  useEffect(() => {
    if (vendorList.length === 1 && vendorList[0].internal_sales === true) {
      setInternalSales(true);
    } else {
      setInternalSales(false);
    }
  }, [vendorList]);

  useEffect(() => {
    if (flag === ERROR_FLAG) {
      dispathErrorEvent();
    }
  }, [flag]);

  return (
    <div className="App">
      <div className="order-receipt">
        <section>
          <div className="order-receipt--inner">
            <Spinner loading={loading} loadingText="Finner aktuelle leverandører"></Spinner>
            <Error flag={flag}></Error>
            <Receipt internalSales={internalSales} loading={loading} vendorList={vendorList} flag={flag}></Receipt>
          </div>
        </section>
      </div>
    </div>
  );
}
